import { call, put } from 'redux-saga/effects';
import { 
  SET_DATA_FILTER,
  SET_FILTER_OPTIONS,
  FILTER_OPTIONS_FAILURE,
  SET_FILTER_LOADING,
  CLEAN_FILTER_DATA,
  SET_ORGANIZATIONS_NAMES,
  SET_SELECTED_ORGANIZATIONS_NAMES,
  UPDATE_CUSTOMER_FIELD
} from '../reducers/filters';
import { getProblemsTypes } from '../api/problems-service';
import { getCustomers } from '../api/customer-service';
import { getCoordinatesProblems, getOrganizations, updateOrganizationsNames } from './actions';
import { CLEAN_PROBLEMS_DATA } from '../reducers/upa-data';
import { searchOrganization } from '../api/organization-service';

export function* updateFilterSaga({ payload }) {
  payload.pageNumber = 0;
  yield put({ type: SET_DATA_FILTER, payload });
  yield put(getCoordinatesProblems(payload));
}

export function* updateCustomerSaga({ payload }) {
  yield put({ type: UPDATE_CUSTOMER_FIELD, payload });
  yield put(getOrganizations(payload));
  yield put(updateOrganizationsNames([]));
}

export function* cleanFilter() {
  yield put({ type: CLEAN_FILTER_DATA });
  yield put({ type: CLEAN_PROBLEMS_DATA });
}

export function* getFilterOptionsSaga() {
  yield put({ type: SET_FILTER_LOADING, payload: true });
  try {
    const problemsTypes = yield call(getProblemsTypes);
    const customers = yield call(getCustomers);
    yield put(getOrganizations(customers[0]));
    yield put({ type: SET_FILTER_OPTIONS, payload: { customers, problemsTypes } });
  } catch (err) {
    yield put({ type: FILTER_OPTIONS_FAILURE, payload: err });
  } finally {
    yield put({ type: SET_FILTER_LOADING, payload: false });
  }
}

export function* getOrganizationsSaga({ payload }) {
  yield put({ type: SET_FILTER_LOADING, payload: true });
  try {
    const organizations = yield call(searchOrganization, payload);
    yield put({ type: SET_ORGANIZATIONS_NAMES, payload: organizations });
  } catch (err) {
    yield put({ type: FILTER_OPTIONS_FAILURE, payload: err });
  } finally {
    yield put({ type: SET_FILTER_LOADING, payload: false });
  }
}

export function* updateOrganizationsNamesSaga({ payload }) {
  try {
    yield put({ type: SET_SELECTED_ORGANIZATIONS_NAMES, payload });
  } catch (err) {
    yield put({ type: FILTER_OPTIONS_FAILURE, payload: err });
  }
}


// WEBPACK FOOTER //
// ./src/sagas/filters.js